var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable } from 'mobx';
import { TraitConditionEvaluator } from './TraitConditionEvaluator';
import { TraitCondition } from '../condition/TraitCondition';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { ConditionSideEvaluatorContext } from '../../context/conditionEvaluator/ConditionSideEvaluatorContext';
export class TraitConditionSideEvaluator extends TraitConditionEvaluator {
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get context() {
        return new ConditionSideEvaluatorContext(this);
    }
    get parentEvaluator() {
        return this.parent;
    }
    get parentCondition() {
        return this.parent.traitCondition;
    }
    get attachedTrait() {
        return this.parent.attachedTrait;
    }
    createTraitCondition() {
        this.setTraitCondition(TraitCondition.fromSerialized({ parent: this.parentCondition }));
    }
}
__decorate([
    memoize
], TraitConditionSideEvaluator.prototype, "context", null);
__decorate([
    action.bound
], TraitConditionSideEvaluator.prototype, "createTraitCondition", null);
